module.exports = __webpack_public_path__ + "static/media/pdf.5227ead6.svg";